import {Inject, Injectable, Optional} from "@angular/core";
import {MomentDateAdapter} from "@angular/material-moment-adapter";
import {MAT_DATE_LOCALE} from "@angular/material/core";

@Injectable()
export class MondayMomentDateAdapter extends MomentDateAdapter {
	constructor(@Optional() @Inject(MAT_DATE_LOCALE) dateLocale: string) {
		super(dateLocale);
	}

	getFirstDayOfWeek(): number {
		return 1;
	}
}
